/* Hearth & Hush: tap/click to enlarge the benefit and size cards and the product photo. */
(function(){
  if(window.__hhInteract)return;window.__hhInteract=1;
  var css='.hhz{position:fixed;inset:0;z-index:99999;background:rgba(48,33,24,.78);display:grid;place-items:center;opacity:0;pointer-events:none;transition:opacity .25s;cursor:zoom-out;overflow:hidden}'
   +'.hhz.on{opacity:1;pointer-events:auto}'
   +'.hhz-host{display:grid;place-items:center;width:100%;height:100%}'
   +'.hhz-x{position:absolute;top:16px;right:18px;width:44px;height:44px;border-radius:50%;border:0;background:rgba(250,243,234,.92);color:#4A3327;font-size:26px;line-height:1;cursor:pointer;z-index:2}'
   +'.hhz-img{width:min(92vw,86vh);height:auto;max-height:90vh;object-fit:contain;display:block}'
   +'.hhz .hh-zc{flex:none !important;pointer-events:none;box-shadow:0 20px 60px rgba(0,0,0,.35);background:linear-gradient(160deg,#F7E9DA 0%,#F1DCC8 100%) !important;opacity:1 !important;filter:none !important;color:#4A3327 !important;transform:none !important}'
   +'.hh-zin{cursor:zoom-in}'
   +'.hh-zin:focus-visible{outline:2px solid #C1694F;outline-offset:3px}'
   +'.hh-hint{position:absolute;right:10px;bottom:10px;width:28px;height:28px;border-radius:50%;background:rgba(74,51,39,.55);color:#FAF3EA;display:grid;place-items:center;font-size:15px;line-height:1;pointer-events:none}'
   +'.hhc-slide.alt,.hhp-slide.alt{position:relative}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
  var ov=document.createElement('div');ov.className='hhz';ov.setAttribute('role','dialog');ov.setAttribute('aria-label','Enlarged view');
  ov.innerHTML='<button type="button" class="hhz-x" aria-label="Close">&times;</button><div class="hhz-host"></div>';
  document.body.appendChild(ov);
  var host=ov.querySelector('.hhz-host');
  function close(){ov.classList.remove('on');setTimeout(function(){if(!ov.classList.contains('on'))host.innerHTML=''},260)}
  ov.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  var canZoom=window.CSS&&CSS.supports&&CSS.supports('zoom','2');
  function openCard(el){
    var r=el.getBoundingClientRect();if(!r.width)return;
    var c=el.cloneNode(true);
    c.classList.add('hh-zc');c.classList.remove('hh-zin');
    c.removeAttribute('tabindex');c.removeAttribute('role');
    var k=Math.min(window.innerWidth*.92/r.width,window.innerHeight*.88/r.height,2.4);
    c.style.width=r.width+'px';c.style.height=r.height+'px';c.style.aspectRatio='auto';
    if(canZoom){c.style.zoom=k}else{c.style.setProperty('transform','scale('+k+')','important');c.style.transformOrigin='center center'}
    var hint=c.querySelector('.hh-hint');if(hint)hint.remove();
    host.innerHTML='';host.appendChild(c);ov.classList.add('on');
  }
  function openImg(img){
    var i=new Image();i.src=img.currentSrc||img.src;i.alt=img.alt||'';i.className='hhz-img';
    host.innerHTML='';host.appendChild(i);ov.classList.add('on');
  }
  function wireCard(el){
    if(el.dataset.hhZ)return;el.dataset.hhZ=1;
    el.classList.add('hh-zin');el.setAttribute('tabindex','0');el.setAttribute('role','button');el.setAttribute('aria-label','Enlarge');
    var hint=document.createElement('span');hint.className='hh-hint';hint.setAttribute('aria-hidden','true');hint.textContent='+';el.appendChild(hint);
    el.addEventListener('click',function(){openCard(el)});
    el.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();openCard(el)}});
  }
  function wireImg(img){
    if(img.dataset.hhZ)return;img.dataset.hhZ=1;
    img.classList.add('hh-zin');
    img.addEventListener('pointermove',function(e){
      if(e.pointerType!=='mouse')return;
      var r=img.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
      img.style.transition='transform .06s linear';
      img.style.transform='perspective(800px) rotateY('+(x*10)+'deg) rotateX('+(-y*10)+'deg) scale(1.03)';
    });
    img.addEventListener('pointerleave',function(){img.style.transition='transform .25s ease-out';img.style.transform=''});
    img.addEventListener('click',function(){openImg(img)});
  }
  function wireAll(){
    document.querySelectorAll('.hhc-slide.alt,.hhp-slide.alt').forEach(wireCard);
    document.querySelectorAll('.hhp-slide:not(.alt) .hhp-img').forEach(wireImg);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wireAll);else wireAll();
  setTimeout(wireAll,600);setTimeout(wireAll,1800);

  /* High-resolution plush photos (hosted in Shopify Files). */
  var HQ='https://cdn.shopify.com/s/files/1/0734/5474/7727/files/';
  var NAMES=['bram','hazel','hollis','wilder'];
  function hqFor(u){
    if(!u||u.indexOf('hh-photo-')<0||u.indexOf('-hq')>-1)return '';
    for(var i=0;i<NAMES.length;i++){if(u.indexOf('hh-photo-'+NAMES[i]+'.webp')>-1)return HQ+'hh-photo-'+NAMES[i]+'-hq.webp'}
    return '';
  }
  function swap(img){
    if(!img||img.tagName!=='IMG')return;
    var h=hqFor(img.getAttribute('src'));
    if(h){img.removeAttribute('srcset');img.setAttribute('src',h)}
  }
  function swapAll(root){(root||document).querySelectorAll('img[src*="hh-photo-"]').forEach(swap)}
  swapAll();
  if(window.MutationObserver){
    new MutationObserver(function(ms){
      ms.forEach(function(m){
        if(m.type==='attributes'){swap(m.target)}
        m.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.tagName==='IMG')swap(n);else if(n.querySelectorAll)swapAll(n)}});
      });
    }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['src']});
  }
  setTimeout(swapAll,600);setTimeout(swapAll,1800);
})();
